<app-page headline="Pricing">
  <div center-layout>
    <div grid-layout gap="md" templateColumns="1fr 1fr" [fullWidth]="true">
      <div
        stack-layout
        borderRadius="xs"
        border="light"
        paddingHorizontal="lg"
        paddingVertical="md"
        gap="sm"
        alignItems="center"
        [minWidth]="460"
        elevation="raised"
      >
        <Text role="headline-small"> Download Pricing Data </Text>

        <div center-layout [grow]="1" [fullWidth]="true">
          <div stack-layout gap="md" [fullWidth]="true">
            <div stack-layout [fullWidth]="true">
              <div box-layout paddingLeft="sm">
                <Text role="headline-small">DCC <span style="color: #d32f2f">*</span></Text>
              </div>
              <div row-layout [grow]="1">
                <app-select
                  [options]="dcc.deviceCareCenterOptions()"
                  [form]="downloadForm"
                  controlName="deviceCareCenter"
                  placeholder=""
                />
              </div>
            </div>
            <div stack-layout [fullWidth]="true">
              <div box-layout paddingLeft="sm">
                <Text role="headline-small">Warehouse <span style="color: #d32f2f">*</span></Text>
              </div>
              <div row-layout [grow]="1">
                <app-select
                  [options]="warehouseOptions()"
                  [form]="downloadForm"
                  controlName="warehouseCode"
                  [placeholder]="
                    warehouseOptions().length > 0
                      ? '--select a Warehouse--'
                      : '--select a DCC--'
                  "
                />
              </div>
            </div>
          </div>
        </div>

        <div box-layout justifyContent="center">
          <app-download-button
            mode="text"
            [blobObservable]="
              pricing.downloadPricingFile(
                selectedDcc() ?? '',
                selectedWms() ?? ''
              )
            "
            [downloadFileName]="pricingFileName()"
            [disable]="!selectedDcc() || !selectedWms()"
          />
        </div>
      </div>

      @if (permissionToUpload()) {
        <app-card
          headline="Upload New Pricing File"
          [loading]="pricing.pricingFileUploading()"
          [loadingError]="pricing.pricingFileUploadError()"
          [loadingProgress]="pricing.pricingFileUploadProgress()"
          [loadingMessage]="
            pricing.pricingFileUploadError()
              ? 'Errors found. Processing...'
              : 'Uploading Pricing File...'
          "
        >
          <div
            ngProjectAs="header-content"
            style="flex: 0 0 280px; max-width: 100%"
          >
            <oui-select
              [(value)]="salesChannelCode"
              [options]="salesChannel.salesChannelOptions()"
              placeholder="...select a sales channel"   
               style="display: block; width: 100%"
            />
          </div>

          <oui-file-drop-zone
            #fileDropZone
            [height]="160"
            (fileAttached)="handleFileAttached($event)"
            (fileRemoved)="selectedFile.set(undefined)"
            [allowedFileExtensions]="['xlsx', 'xls']"
            style="width: 100%"
            [helpTemplate]="fileDropZoneContent"
          />
          <ng-template #fileDropZoneContent>
            <div stack-layout [fullWidth]="true" alignItems="center" gap="sm">
              <Text role="headline-small" align="center">
                Drag and drop the file here.
              </Text>
              <Text role="title-small" align="center">
                Only .xlsx files with headers SKU, WarehouseCode, BuyNowPrice,
                and ReservePrice will be accepted.
              </Text>
            </div>
          </ng-template>
          <div
            row-layout
            justifyContent="space-between"
            [fullWidth]="true"
            gap="md"
          >
            <button
              text-button
              size="md"
              variant="secondary"
              (click)="fileDropZone.openFileSelector()"
            >
              Browse Files
            </button>
            <button
              text-button
              size="md"
              (click)="uploadFile()"
              [disable]="!selectedFile() || !salesChannelCode"
            >
              Upload
            </button>
          </div>
        </app-card>
      }
    </div>
  </div>
  <div box-layout paddingVertical="md" [grow]="1">
    @if (pricing.noUploadHistory()) {
      <div center-layout [grow]="1" [fullWidth]="true">
        <Text role="title-large">No pricing upload history.</Text>
      </div>
    }

    <app-log-table
      [datasource]="uploadHistoryDatasource"
      label="Pricing Upload History"
      [loading]="pricing.uploadHistory.isLoading()"
      (reload)="pricing.uploadHistory.reload()"
    />
  </div>
</app-page>
